export default "__VITE_PUBLIC_ASSET__d912defa__"